// extracted by mini-css-extract-plugin
module.exports = {"container":"ReusableContentA_container__QLoMM","content":"ReusableContentA_content__2YzJw"};